import { render, staticRenderFns } from "./photoGalleryConfirmationModal.vue?vue&type=template&id=785aa962&"
import script from "./photoGalleryConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./photoGalleryConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports